"use strict";
// tslint:disable
// eslint-disable
/**
 * Roles and Rights API
 * API for configurable roles and rights
 *
 * The version of the OpenAPI document: 1.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var runtime_1 = require("../runtime");
var _1 = require("./");
function RemoveRoleSuccessFromJSON(json) {
    return RemoveRoleSuccessFromJSONTyped(json, false);
}
exports.RemoveRoleSuccessFromJSON = RemoveRoleSuccessFromJSON;
function RemoveRoleSuccessFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'oldRole': !runtime_1.exists(json, 'oldRole') ? undefined : _1.RoleFromJSON(json['oldRole']),
    };
}
exports.RemoveRoleSuccessFromJSONTyped = RemoveRoleSuccessFromJSONTyped;
function RemoveRoleSuccessToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'oldRole': _1.RoleToJSON(value.oldRole),
    };
}
exports.RemoveRoleSuccessToJSON = RemoveRoleSuccessToJSON;
